<style>
  .material-symbols-outlined {
    font-variation-settings: 'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
  }
</style>

<ng-template
  #monthCellTemplate
  let-day="day"
  let-openDay="openDay"
  let-locale="locale"
  let-tooltipPlacement="tooltipPlacement"
  let-highlightDay="highlightDay"
  let-unhighlightDay="unhighlightDay"
  let-eventClicked="eventClicked"

>
  <div
    class="fill-height"
    [ngClass]="{
   'full-1': this.loadOrePrevisteTot(day.events) == 1,
   'full-2': this.loadOrePrevisteTot(day.events) == 2,
   'full-3': this.loadOrePrevisteTot(day.events) == 3,
   'full-4': this.loadOrePrevisteTot(day.events) == 4,
   'full-5': this.loadOrePrevisteTot(day.events) == 5,
   'full-6': this.loadOrePrevisteTot(day.events) == 6,
   'full-7': this.loadOrePrevisteTot(day.events) == 7,
   'full-8': this.loadOrePrevisteTot(day.events) >= 8,
   'isToday': day.date.getTime() == this.viewDate.getTime(),
   'isDragging': this.isDragging
    }"
    [contextMenuSubject]="day.date"
    (mouseup)="this.mouseup(day)"
  >
    <div class="cal-cell-top" style="text-align: left !important;">
      <div style="width: 100%; text-align: left; display: grid; padding-left: 2px">
        <ng-container *ngIf="!this.isDragging">
          <span style="width: 50%">
            <b style="color: {{this.apiService.dashColor}}"> Ore previste: {{this.loadOrePrevisteTot(day.events)}}</b>
          </span>
          <span style="width: 50%">
            <b style="color: {{this.apiService.dashColor}}">Ore effettive: <span
              style="color: #b40505">{{this.loadOreEffettiveTot(day.events)}}</span></b>
          </span>
          <span style="width: 50%">
            <b style="color: {{this.apiService.dashColor}}">Ore rapportinate: <span
              style="color: #b40505">{{this.loadOreRapportinateTot(this.TransformDataFormatToSave(day.date))}}</span></b>
          </span>
        </ng-container>
        <ng-container *ngIf="this.isDragging">
        <h2 style="color: {{this.apiService.dashColor}}; width: 100%; text-align: center"><b>Cambia data in: {{this.TransformDataFormatToShow(day.date)}}</b></h2>
        </ng-container>
      </div>
      <!--<div style="width: 100%; display: flex" *ngIf="this.isEventSetForUser(day.date)">
        <mat-icon>done</mat-icon>
        <span style="margin: 2%">{{this.getEventType(day.date)}}</span> [contextMenu]="basicMenu"
      </div>-->
      <hr style="color: {{this.apiService.dashColor}}; margin: 0">
      <div style="width:100%; text-align: left" *ngIf="false">
        <span *ngIf="this.getNumInterventi(day.events) > 0" style="margin: 2%"
        >Interventi: {{ this.getNumInterventi(day.events) }}</span
        ></div>


      <span class="cal-day-number" style="color: black"
      >{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span
      >

    </div>

    <div class="cal-events" cdkDropList
         (cdkDropListDropped)="onDrop($event)">
      <div *ngFor="let event of day.events" (mouseup)="this.mouseup(day)">
        <div
          *ngIf="event.id == 'schedulazione' && this.hideFeriePermessiVar == true  && (this.selectedTecnico == '' || event.tecnico == this.selectedTecnico)"
          class="cal-event"  cdkDrag [cdkDragDisabled] = "event.isRapportinato == 1" (cdkDragStarted)="onDragStarted($event)" (cdkDragEnded)="onDragEnded($event)"
          [cdkDragData]="event"
          style="background-color: {{event.extraColor}} !important;
             border-color: {{event.extraColor}} !important;
             color: #fff !important;" matTooltipPosition="above"
          (mouseenter)="highlightDay.emit({event: event})" [matTooltipShowDelay]="0"
          (mouseleave)="unhighlightDay.emit({event: event})" matTooltip="Utente: {{event.tecnico}}"
          (click)="$event.stopPropagation(); eventClicked.emit({event: event, sourceEvent: day})"
          [@dragAnimation]="'active'">
          <ng-container *ngIf="event.isRapportinato">
            <mat-icon title="Rapportinato" style="float: left;
    width: 100%;
    text-align: left;">done
            </mat-icon>
            <br>
            <hr>
          </ng-container>
          <h4 style="text-align: left;" class="h4event">{{event.title}}
          </h4>

          <h4 style="text-align: left;" class="h4event"> Ore previste: {{event.hourNumber}}</h4>
          <h4 style="text-align: left;" class="h4event"><u>Ore effettive: {{event.oreEffettive}}</u></h4>
        </div>
      </div>


    </div>
  </div>
</ng-template>


<context-menu #basicMenu style="width: 100% !important;" (open)="this.setDayOpened($event)">
  <ng-template contextMenuItem (execute)="this.addIntervent()" passive="true">
    Data checklist: {{this.TransformDataFormatToShow(this.clickedDate)}}
  </ng-template>
  <ng-template contextMenuItem (execute)="this.addIntervent()">
    <button mat-button style="width: 100%;color: {{this.apiService.dashColor}}"> Aggiungi checklist</button>
  </ng-template>
</context-menu>

<div style="display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100%;">
  <mat-card class="cardcomponentMasks" id="style-4">
    <h3 class="titles" style="color:{{this.apiService.dashColor}}; text-align: left">


    </h3>
    <!--<hr class="riga" style="color:{{this.apiService.dashColor}}; margin-bottom: 1% !important">-->

    <mat-card-content><!--hai cliccato la maschera con id: {{this.id}}-->
      <div style="heigth: 5%; width: 100%; display: flex; margin-bottom: 1%; flex-wrap: wrap;"
           *ngIf="this.hideFeriePermessiVar == true">
        <ng-container *ngFor="let tec of this.dataLegenda">
          <div style="display: flex; ">
            <button mat-button (click)="this.showTecnico(tec.nome)">
              <mat-icon class="material-symbols-outlined" style="color: {{tec.colore}}; width: 30px;">
                circle
              </mat-icon>
              <span style="width: fit-content; margin: auto;"><b
                *ngIf="this.selectedTecnico.toLowerCase() == tec.nome.toLowerCase()">{{tec.nome}}</b><span
                *ngIf="this.selectedTecnico.toLowerCase() != tec.nome.toLowerCase()">{{tec.nome}}</span></span>
            </button>
          </div>
        </ng-container>
      </div>
      <div *ngIf="this.selectedTecnico != ''" style="width: 100%; text-align:left">
        <b style="color: {{this.apiService.dashColor}}">{{this.selectedTecnico}} impegno totale: {{this.impegnoTotale}}
          ore (a partire da oggi)</b>
      </div>
      <hr class="riga" style="color:{{this.apiService.dashColor}};">
      <div style="display: flex">
        <div style="width: 40%; text-align: left">
          <h1
            style="text-transform: uppercase; color: black">{{ viewDate | calendarDate:(view + 'ViewTitle'):'it' }}</h1>
        </div>

        <div style="width: 60%; text-align: right">
          <div class="btn btn-primary"
               style="background-color: {{this.apiService.dashColor}}; border-color: {{this.apiService.dashColor}}"
               mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate">
            Indietro
          </div>
          <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
            Oggi
          </div>
          <div class="btn btn-primary"
               style="background-color: {{this.apiService.dashColor}}; border-color: {{this.apiService.dashColor}}"
               mwlCalendarNextView [view]="view" [(viewDate)]="viewDate">
            Avanti
          </div>
        </div>


      </div>
      <mwl-calendar-month-view
        id="calendario"
        [viewDate]="viewDate"
        (dayClicked)="cellClicked($event)"
        (eventClicked)="this.eventClick($event)"
        [events]="events"
        [refresh]="refresh"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [cellTemplate]="monthCellTemplate"
        [weekendDays]="weekendDays">
      </mwl-calendar-month-view>
    </mat-card-content>
    <div style="text-align: left;">

    </div>

  </mat-card>
</div>

